/*
 * Lista de filtros para la lista de productos de proveedores.
 *
 * Contiene los componentes de buscador general, un selector de marcas, de subcategorías,
 * de proveedores. Tambien un componente para indicar las columnas visibles y un botón para
 * descargar un archivo PDF.
 *
 * Created on Tue Jul 18 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>

    <b-form-row style="gap:8px">

      <!-- #region::Searcher -->
      <b-col :md="2">
        <BasicSearcher
          ref="basic-searcher"
          :callback="handleSearch"
          placeholder="Buscar"
        />
      </b-col>
      <!-- #endregion end::Searcher -->

      <!-- #region::Brand filter -->
      <b-col
        v-if="!isCircuits"
        md="2"
      >
        <v-select
          v-model="selectedBrand"
          label="Name"
          class="style-chooser"
          placeholder="Marca"
          :options="getBrands"
        />
      </b-col>
      <!-- #endregion::Brand filter -->
      <!-- #region::Subcategory filter -->
      <b-col
        v-if="!isCircuits"
        md="2"
      >
        <v-select
          v-model="selectedCategory"
          label="Name"
          class="style-chooser"
          placeholder="Categoría"
          :options="getCategorie"
        />
      </b-col>
      <!-- #region::Category filter -->
      <b-col
        v-if="!isCircuits"
        md="2"
      >
        <v-select
          v-model="selectedSubCategory"
          label="Name"
          class="style-chooser"
          placeholder="Subcategoría"
          :options="getCategories"
        />
      </b-col>
      <b-col
        v-if="!isCircuits"
        md="2"
      >
        <v-select
          v-model="selectedDescription"
          label="text"
          class="style-chooser"
          placeholder="Descripción"
          :options="getDescription"
        />
      </b-col>
      <!-- #endregion::description  filter -->
      <!-- #region::Status select filter -->
      <b-col md="2">
        <v-select
          v-model="selectedEcommerceStatus"
          label="text"
          class="style-chooser"
          style="text-transform: capitalize;"
          placeholder="Estatus"
          :options="getEcommerceStatus"
        />
      </b-col>
      <!-- #endregion::Status select filter -->

      <!-- #region::ID sorter filter -->
      <b-col md="2">
        <v-select
          v-model="selectedHidePrice"
          label="text"
          class="style-chooser"
          placeholder="Precio"
          :options="getHidePrice"
        />
      </b-col>
      <!-- #endregion::ID sorter filter -->

      <!-- #region::favorite  filter -->
      <b-col md="2">
        <v-select
          v-model="selectedFavorite"
          label="text"
          class="style-chooser"
          placeholder="Destacados"
          :options="getFavorite"
        />
      </b-col>
      <!-- #endregion::favorite  filter -->
    </b-form-row>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BCol, BFormRow,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import BasicSearcher from '@/components/forms/BasicSearcher.vue'

export default {
  components: {
    BCol,
    vSelect,
    BFormRow,
    BasicSearcher,
  },
  props: {
    /**
     * Titulo que se muestra en la pestaña
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * verificar si es la pestaña de circuitos
     */
    isCircuits: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedBrand: null,
      selectedSubCategory: null,
      columnsSearchTerm: '',
      selectedHidePrice: '',
      selectedEcommerceStatus: null,
      selectedDescription: null,
      selectedFavorite: null,
      selectedCategory: null,
    }
  },
  computed: {
    ...mapGetters({

      getHidePrice: 'ecommerce/getHidePrice',
      getEcommerceStatus: 'ecommerce/getEcommerceStatus',
      getDescription: 'ecommerce/getDescription',
      getFavorite: 'ecommerce/getFavorite',

      getBrands: 'brands/getBrands',
      getCategories: 'categories/getCategories',
      getCategorie: 'ecommerce/getCategories',

      /**
       * Filtros globales
       */
      getListsParams: 'reportsSuppliers/getListsParams',
      getFilteredStatus: 'filters/getFilteredStatus',
      getFilteredPriceEcom: 'filters/getFilteredPriceEcom',
      getFilteredDescription: 'filters/getFilteredDescription',
      getFilteredFavorite: 'filters/getFilteredFavorite',
      getFilteredBrand: 'filters/getFilteredBrand',
      getFilteredSearchTerm: 'filters/getFilteredSearchTerm',
      getFilteredSubcategory: 'filters/getFilteredSubcategory',
      getFilteredCategory: 'filters/getFilteredCategory',
    }),
    /**
     * Marca filtrada (filtro en store)
     */
    filteredBrand: {
      get() { return this.getFilteredBrand },
    },
    /**
     * Filtro de estatus (filtro en store)
     */
    filteredStatus: {
      get() { return this.getFilteredStatus },
    },
    /**
     * Filtro de precio oferta (filtro en store)
     */
    filteredPriceEcom: {
      get() { return this.getFilteredPriceEcom },
    },
    /**
     * Filtro de para selecionar si tiene o no descripción (filtro en store)
     */
    filteredDescription: {
      get() { return this.getFilteredDescription },
    },
    /**
     * Filtro de para selecionar si es producto destacado (filtro en store)
     */
    filteredFavorite: {
      get() { return this.getFilteredFavorite },
    },
    /**
     * Término de búsqueda filtrado (filtro en store)
     */
    filteredSearchTerm: {
      get() { return this.getFilteredSearchTerm },
    },
    /**
     * Subcategoría filtrada (filtro en store)
     */
    filteredSubcategory: {
      get() { return this.getFilteredSubcategory },
    },
    /**
     * Categoría filtrada (filtro en store)
     */
    filteredCategory: {
      get() { return this.getFilteredCategory },
    },
  },
  mounted() {
    // Carga el término de búsqueda (filtro en store)
    if (this.filteredSearchTerm) {
      this.$refs['basic-searcher'].loadSearchTerm(this.filteredSearchTerm)
    }

    // Carga la marca filtrada (filtro en store)
    this.selectedBrand = this.filteredBrand ? { Name: this.getBrands.find(brand => brand.IdBrand === this.filteredBrand).Name } : null
    this.$watch('selectedBrand', brand => {
      this.$emit('on:filter', { type: 'brand', value: brand !== null ? brand.IdBrand : '' })
    })

    // Carga la subcategoría filtrada (filtro en store)
    this.selectedSubCategory = this.filteredSubcategory ? { Name: this.getCategories.find(subCat => subCat.IdCategory === this.filteredSubcategory).Name } : null
    this.$watch('selectedSubCategory', category => {
      this.$emit('on:filter', { type: 'subCategory', value: category !== null ? category.IdCategory : '' })
    })

    // cargar la categoria filtrada (filtro en store)
    this.selectedCategory = this.filteredCategory ? { Name: this.getCategorie.find(cat => cat.id == this.filteredCategory).Name } : null
    this.$watch('selectedCategory', category => {
      this.$emit('on:filter', { type: 'category', value: category !== null ? category.id : '' })
    })

    this.selectedEcommerceStatus = this.filteredStatus ? { text: this.filteredStatus } : null
    this.$watch('selectedEcommerceStatus', status => {
      this.$emit('on:filter', { type: 'status', value: status !== null ? status.text : '' })
    })

    this.selectedHidePrice = this.filteredPriceEcom ? ({ text: this.filteredPriceEcom === '1' ? 'Visible' : 'Oculto' }) : null
    this.$watch('selectedHidePrice', hidePrice => {
      this.$emit('on:filter', { type: 'price', value: hidePrice !== null ? hidePrice.text : '' })
    })

    this.selectedDescription = this.filteredDescription ? { text: this.filteredDescription } : null
    this.$watch('selectedDescription', description => {
      this.$emit('on:filter', { type: 'description', value: description !== null ? description.text : '' })
    })

    this.selectedFavorite = this.filteredFavorite ? { text: this.filteredFavorite === '1' ? 'Ver solo destacados' : 'Ver todos' } : null
    this.$watch('selectedFavorite', favorite => {
      this.$emit('on:filter', { type: 'favorite', value: favorite !== null ? favorite.text : '' })
    })
  },
  methods: {
    /**
    * Evento del buscador básico
    * @summary Emite un evento con el término de búsqueda y limpia los campos de selección
    * @param {String} searchTerm - Término de búsqueda
    */
    handleSearch(searchTerm) {
      this.$emit('on:filter', { type: 'search', value: searchTerm })

      this.selectedBrand = null
      this.selectedSubCategory = null
      this.selectedCategory = null
      this.selectedEcommerceStatus = null
      this.selectedHidePrice = null
      this.selectedDescription = null
      this.selectedFavorite = null
    },

  },
}
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-autosuggest.scss';
.style-chooser {
  background: #ffffff;
}

.btn-outline-secondary {
  border: 1px solid !important;
  border-color: #c9c9c9 !important;
}
.dropdown-menu {
  min-width: 16rem !important;
}
.vs__selected button {
  display: none
}
</style>
